import { ImageOptions, ImageProps, OriginalImage } from '@/interfaces/models/image';

export default class Image {
  id: string | undefined;
  path: string | undefined;
  original: OriginalImage | undefined;
  options: ImageOptions | undefined;

  public constructor(imageProps: ImageProps = {}) {
    this.id = imageProps.id;
    this.path = imageProps.path;
    this.original = imageProps.original;
    this.options = imageProps.options;
  }
}
